
// important -> POC for ProductConfiguration Service - this will require refactor after graphQL implementation
// note -> GraphQL schema requirements
// required: ['id', 'url', 'name', 'description', 'images', 'optionGroups', 'Result']
export default {

    getOptionGroups ( params ) {
        console.warn( '[WARN: ProductConfigurator.getOptionGroups] - not implemented' );
        return Promise.resolve( {} );
        // return svc.get( '/getProductOptionGroups', {params} )
        //     .then( ServiceProvider.responseData );
    },

    getOptionGroupsCollection ( params ) {
        console.warn( '[WARN: ProductConfigurator.getOptionGroupsCollection] - not implemented' );
        return Promise.resolve( {} );
        // return svc.get( '/getProductOptionGroupsCollection', {params} )
        //     .then( ServiceProvider.responseData );
    }

};











